// extracted by mini-css-extract-plugin
module.exports = {"divider":"ViewTemplate_divider__1w59J","languageDropdown":"ViewTemplate_languageDropdown__lNo29"};